let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dlmud"), load("5CGnz"), load("bNv64"), load("dXu4x"), load("3CucM"), load("9yemY")]).then(() => parcelRequire('ca8zp'));